import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CustomLayoutComponent } from './custom-layout/custom-layout.component';
import { VexRoutes } from '@vex/interfaces/vex-route.interface';
import { AuthGuard } from '@vex/authentication/auth/auth.guard';
import { CookieService } from '@vex/services/cookie.service';

const routes: VexRoutes = [
  {
    path: 'login',
    loadChildren: () => import('./auth/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./auth/forgot-password/forgot-password.module').then((m) => m.ForgotPasswordModule)
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('./auth/reset-password/reset-password.module').then((m) => m.ResetPasswordModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./auth/register/register.module').then((m) => m.RegisterModule)
  },
  {
    path: '',
    component: CustomLayoutComponent,
    children: [
      {
        canActivate: [AuthGuard],
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        canActivate: [AuthGuard],
        path: 'unauthorized',
        loadChildren: () => import('./error-page/error-page.module').then((m) => m.ErrorPageModule)
      },
      {
        canActivate: [AuthGuard],
        path: 'onboard',
        loadChildren: () => import('./onboard/onboard.module').then((m) => m.OnBoardModule)
      },
      {
        canActivate: [AuthGuard],
        path: 'dashboard',
        loadChildren: () => import('./dashboards/dashboard.module').then((m) => m.DashboardModule)
      },
      {
        canActivate: [AuthGuard],
        path: 'security',
        loadChildren: () => import('./security/security.module').then((m) => m.SecurityModule)
      },
      {
        canActivate: [AuthGuard],
        path: 'deployment',
        loadChildren: () => import('./deployment/deployment.module').then((m) => m.DeploymentModule)
      },
      {
        canActivate: [AuthGuard],
        path: 'application-settings',
        loadChildren: () =>
          import('./application-settings/application-settings.module').then(
            (m) => m.ApplicationSettingsModule
          )
      },
      {
        canActivate: [AuthGuard],
        path: 'network-management',
        loadChildren: () =>
          import('./network-management/network-management.module').then(
            (m) => m.NetworkManagementModule
          )
      },
      {
        canActivate: [AuthGuard],
        path: 'migration-pipeline',
        loadChildren: () =>
          import('./migration-pipeline/migration-pipeline.module').then(
            (m) => m.MigrationPipelineModule
          )
      },
      {
        data: { 
          featureIds: [
            '6277fe82141ea79810373de4'
          ]
        },
        canLoad: [AuthGuard],
        path: 'connectivity',
        loadChildren: () =>
          import('./network-management/connectivity/create-connectivity/connectivity.module').then(
            (m) => m.ConnectivityModule
          )
      },
      {
        data: { 
          featureIds: [
            '61df218fa354775fa8fa63c8'
          ]
        },
        canLoad: [AuthGuard],
        path: 'discovery',
        loadChildren: () =>
          import('./network-management/discovery/discovery.module').then(
            (m) => m.DiscoveryModule
          )
      },
      {
        data: { 
          featureIds: [
            '64f188033544b2f8e5ea2af1',
            '664fbd3eea6a069056091354'
          ]
        },
        canLoad: [AuthGuard],
        path: 'device',
        loadChildren: () =>
          import('./network-management/device/device.module').then(
            (m) => m.DeviceModule
          )
      },
      {
        data: { 
          featureIds: [
            '627800b3141ea7981037402f'
          ]
        },
        canLoad: [AuthGuard],
        path: 'ip-pools',
        loadChildren: () =>
          import('./network-management/ip-pools/ip-pools.module').then(
            (m) => m.IPPoolModule
          )
      },
      {
        data: { 
          featureIds: [
            '66851c952e63ac5bcee14353'
          ]
        },
        canLoad: [AuthGuard],
        path: 'workflow',
        loadChildren: () =>
          import('./network-management/workflow/workflow.module').then(
            (m) => m.WorkflowModule
          )
      },
      {
        data: { 
          featureIds: [
            '664fbd95ea6a069056091d51'
          ]
        },
        canLoad: [AuthGuard],
        path: 'location',
        loadChildren: () =>
          import('./network-management/data-center-site/data-center-site.module').then(
            (m) => m.DataCenterSiteModule
          )
      },
      {
        canActivate: [AuthGuard],
        path: 'blueprintdesigner',
        loadChildren: () =>
          import('./blue-print-designer/blue-print-designer.module').then(
            (m) => m.BluePrintDesignerModule
          )
      },
      {
        canActivate: [AuthGuard],
        path: 'platform-settings',
        loadChildren: () =>
          import('./platform-settings/platform-settings.module').then(
            (m) => m.PlatformSettingsModule
          )
      },
      {
        canActivate: [AuthGuard],
        path: 'operations',
        loadChildren: () => import('./operations/operations.module').then((m) => m.OperationsModule)
      },
      {
        canActivate: [AuthGuard],
        path: 'compliance',
        loadChildren: () => import('./compliance/compliance.module').then((m) => m.ComplianceModule)
      },
      {
        canActivate: [AuthGuard],
        path: 'user-setting',
        loadChildren: () =>
          import('./user-setting/user-setting.module').then((m) => m.UserSettingModule)
      },
      {
        canActivate: [AuthGuard],
        path: 'agent-studio',
        loadChildren: () =>
          import('./agent-studio/agent-studio.module').then((m) => m.AgentStudioModule)
      },
      {
        canActivate: [AuthGuard],
        path: 'network-discovery',
        loadChildren: () =>
          import('./network-discovery/network-discovery.module').then((m) => m.NetworkDiscoveryModule)
      }
      // {
      //   path: '**',
      //   loadChildren: () => import('./pages/pages/errors/error-404/error-404.module').then(m => m.Error404Module)
      // }
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
      relativeLinkResolution: 'corrected',
      anchorScrolling: 'enabled'
    })
  ],
  exports: [RouterModule],
  providers: [CookieService]
})
export class AppRoutingModule {}
